module.exports = __webpack_public_path__ + "static/img/guide.52164ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OauthApply/guide.png
// module id = /bC7
// module chunks = 1